import {Component} from '@angular/core';

@Component({
  template: '<div>PageNotFoundComponent</div>',
})
export class PageNotFoundComponent {

}
